import { ISubmissionSettingsObject } from 'wisestep-api';

export type submissionFieldsArrayType =
  | 'name'
  | 'email'
  | 'phoneNumber'
  | 'uploadCV'
  | 'messengerId'
  | 'visaType'
  | 'visaValidity'
  | 'nationality'
  | 'aadharNumber'
  | 'alternateEmail'
  | 'alternatePhoneNumber'
  | 'businessUnit'
  | 'certifications'
  | 'clientBillRate'
  | 'currentCompensation'
  | 'currentEmployer'
  | 'currentJobTitle'
  | 'currentLocation'
  | 'desiredJobTitles'
  | 'dob'
  | 'expectedAllowance'
  | 'expectedCompensation'
  | 'gender'
  | 'highestEducation'
  | 'languagesKnown'
  | 'linkedInURL'
  | 'notes'
  | 'reasonForChange'
  | 'skills'
  | 'totalExperience'
  | 'tags'
  | 'workAuthorization'
  | 'workAuthorizationCategory'
  | 'workAuthValidity'
  | 'jobPreferences'
  | 'jobType'
  | 'candidateID'
  | 'source'
  | 'otherDocuments'
  | 'relevantExperience'
  | 'institutesAttended'
  | 'previousJobTitles'
  | 'previousEmployers'
  | 'preferredLocation'
  | 'relocationPreferences'
  | 'communicationPreferences'
  | 'availableTimeSlot'
  | 'noticePeriod'
  | 'interviewingAnywhereElse'
  | 'yourAssessment'
  | 'questions'
  | 'familyWillingToRelocate'
  | 'otherAllowance'
  | 'otherInterviewStage'
  | 'currentJobIncludeTravel'
  | 'willingToTravel'
  | 'willingToRelocate'
  | 'candidatePersonalId'
  | 'rtrConsent'
  | 'passportType'
  | 'passportNumber'
  | 'age'
  | 'postalAddress'
  | 'ssnNumber'
  | 'panCard'
  | 'offeredPayRate'
  | 'personalWebsite'
  | 'portalId'
  | 'skillMatrix'
  | 'exEmployeeOfClient'
  | 'exEmployeeId';

const defaultFieldValues: ISubmissionSettingsObject = {
  hidden: true,
  disabled: false,
  required: false,
  label: '',
};

const defaultMandatoryFieldValues: ISubmissionSettingsObject = {
  hidden: false,
  disabled: true,
  required: true,
  label: '',
};

// Default values for the form fields
export const defaultFormValues = {
  name: { ...defaultMandatoryFieldValues, label: 'Name' },
  email: { ...defaultMandatoryFieldValues, label: 'Email' },
  phoneNumber: { ...defaultMandatoryFieldValues, label: 'Phone Number' },
  uploadCV: { ...defaultMandatoryFieldValues, label: 'Upload CV' },
  messengerId: { ...defaultFieldValues, label: 'Messenger ID' },
  visaType: { ...defaultFieldValues, label: 'Visa Type' },
  visaValidity: { ...defaultFieldValues, label: 'Visa Validity' },
  nationality: { ...defaultFieldValues, label: 'Nationality' },
  aadharNumber: { ...defaultFieldValues, label: 'Aadhar Number' },
  alternateEmail: { ...defaultFieldValues, label: 'Alternate Email' },
  alternatePhoneNumber: { ...defaultFieldValues, label: 'Alternate Phone Number' },
  businessUnit: { ...defaultFieldValues, label: 'Business Unit' },
  certifications: { ...defaultFieldValues, label: 'Certifications' },
  clientBillRate: { ...defaultFieldValues, label: 'Client Bill Rate' },
  currentCompensation: { ...defaultFieldValues, label: 'Current Compensation' },
  currentEmployer: { ...defaultFieldValues, label: 'Current Employer' },
  currentJobTitle: { ...defaultFieldValues, label: 'Current Job Title' },
  currentLocation: { ...defaultFieldValues, label: 'Current Location' },
  desiredJobTitles: { ...defaultFieldValues, label: 'Desired Job Titles' },
  dob: { ...defaultFieldValues, label: 'Date of Birth' },
  expectedAllowance: { ...defaultFieldValues, label: 'Expected Allowance' },
  expectedCompensation: { ...defaultFieldValues, label: 'Expected Compensation' },
  gender: { ...defaultFieldValues, label: 'Gender' },
  highestEducation: { ...defaultFieldValues, label: 'Highest Education' },
  languagesKnown: { ...defaultFieldValues, label: 'Languages Known' },
  notes: { ...defaultFieldValues, label: 'Notes' },
  reasonForChange: { ...defaultFieldValues, label: 'Reason for Change' },
  skills: { ...defaultFieldValues, label: 'Skills' },
  totalExperience: { ...defaultFieldValues, label: 'Total Experience' },
  tags: { ...defaultFieldValues, label: 'Tags' },
  workAuthorization: { ...defaultFieldValues, label: 'Work Authorization' },
  workAuthorizationCategory: { ...defaultFieldValues, label: 'Work Authorization Category' },
  workAuthValidity: { ...defaultFieldValues, label: 'Work Authorization validity' },
  linkedInURL: { ...defaultFieldValues, label: 'LinkedIn URL' },

  // Additional fields from the list
  jobPreferences: { ...defaultFieldValues, label: 'Job Preferences' },
  jobType: { ...defaultFieldValues, label: 'Job Type' },
  candidateID: { ...defaultFieldValues, label: 'Candidate ID' },
  source: { ...defaultFieldValues, label: 'Source' },
  otherDocuments: { ...defaultFieldValues, label: 'Other Documents' },
  relevantExperience: { ...defaultFieldValues, label: 'Relevant Experience' },
  institutesAttended: { ...defaultFieldValues, label: 'Institutes Attended' },
  previousJobTitles: { ...defaultFieldValues, label: 'Previous Job Titles' },
  previousEmployers: { ...defaultFieldValues, label: 'Previous Employers' },
  preferredLocation: { ...defaultFieldValues, label: 'Preferred Location' },
  relocationPreferences: { ...defaultFieldValues, label: 'Relocation Preferences' },
  communicationPreferences: { ...defaultFieldValues, label: 'Communication Preferences' },
  availableTimeSlot: { ...defaultFieldValues, label: 'Available Time Slot' },
  noticePeriod: { ...defaultFieldValues, label: 'Notice Period' },
  interviewingAnywhereElse: { ...defaultFieldValues, label: 'Interviewing Anywhere Else' },
  yourAssessment: { ...defaultFieldValues, label: 'Your Assessment' },
  questions: { ...defaultFieldValues, label: 'Questions' },
  familyWillingToRelocate: { ...defaultFieldValues, label: 'Family Willing To Relocate' },
  otherAllowance: { ...defaultFieldValues, label: 'Other Allowance' },
  otherInterviewStage: { ...defaultFieldValues, label: 'Other Interview Stage' },
  currentJobIncludeTravel: { ...defaultFieldValues, label: 'Current Job Include Travel' },
  willingToTravel: { ...defaultFieldValues, label: 'Willing To Travel' },
  willingToRelocate: { ...defaultFieldValues, label: 'Willing To Relocate' },
  candidatePersonalId: { ...defaultFieldValues, label: 'Candidate Personal ID' },
  rtrConsent: { ...defaultFieldValues, label: 'RTR Consent' },
  passportType: { ...defaultFieldValues, label: 'Passport Type' },
  passportNumber: { ...defaultFieldValues, label: 'Passport Number' },
  age: { ...defaultFieldValues, label: 'Age' },
  postalAddress: { ...defaultFieldValues, label: 'Postal Address' },
  ssnNumber: { ...defaultFieldValues, label: 'SSN Number' },
  panCard: { ...defaultFieldValues, label: 'PAN Card' },
  offeredPayRate: { ...defaultFieldValues, label: 'Offered Pay Rate' },
  hasVeteranStatus: { ...defaultFieldValues, label: 'Has Veteran Status' },
  personalWebsite: { ...defaultFieldValues, label: 'Personal Website' },
  securityClearance: { ...defaultFieldValues, label: 'Security Clearance' },
  skillMatrix: { ...defaultFieldValues, label: 'Skill Matrix' },
  exEmployeeOfClient: { ...defaultFieldValues, label: ' Ex Employee of Client' },
  exEmployeeId: { ...defaultFieldValues, label: 'Ex Employee ID' },
  portalId: { ...defaultFieldValues, label: 'Portal ID' },

  importTemplate: '',
};
